var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplantableBiological(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.25,
    height: 82.486,
    viewBox: "0 0 82.25 82.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Implantable_Biological",
    "data-name": "Implantable Biological",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11862",
    "data-name": "Group 11862",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16295",
    "data-name": "Path 16295",
    d: "M13.182,60.329c-4.194,4.992-6.291,4.793-6.291,4.793C-4.292,66.72,1.5,74.708,1.5,74.708S5.294,77.4,5.294,78.8s2.115,3.109,2.115,3.109c9.97,2.918,8.754-6.079,8.51-9s5.107-9,5.107-9C54.339,23.309,67.265,16.253,68.788,15.238s3.384.677,3.384.677c7.184,1.732,9.237-2.38,9.934-4.536.841-2.605-2.025-8.858-7.339-8.351S71.983,1.763,66.606.159,60.766,9.51,58.191,12.1C46.122,24.243,13.182,60.329,13.182,60.329",
    transform: "translate(0 0)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2742",
    "data-name": "Rectangle 2742",
    width: 20.458,
    height: 9.836,
    transform: "translate(40.594 28.639) rotate(-45)",
    fill: "#4c36e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplantableBiological);
export default __webpack_public_path__ + "static/media/ImplantableBiological.c00f3490420b8b02447d6facb8cecb04.svg";
export { ForwardRef as ReactComponent };